import React, { useState } from "react";
import Layout from "../components/layout/layout";
import styles from "./index.module.scss";
import { FaPlayCircle, FaDownload } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import Img from "gatsby-image";
import { graphql } from "gatsby";
import Contact from "../components/contact/contact";
import scrollTo from "gatsby-plugin-smoothscroll";
import ReactModal from "react-modal";
import TheFireSmartHub from "../assets/TheFireSmartHub.mp4";
import wpgGuide from "../assets/af-developing-wildfire-preparedness-guide-2020-01.pdf";

export const query = graphql`
  query {
    step_01: file(relativePath: { eq: "step_01.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    step_02: file(relativePath: { eq: "step_02.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    step_03: file(relativePath: { eq: "step_03.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    step_04: file(relativePath: { eq: "step_04.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    step_05: file(relativePath: { eq: "step_05.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    community_01: file(relativePath: { eq: "community_01.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    community_02: file(relativePath: { eq: "community_02.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    community_03: file(relativePath: { eq: "community_03.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    community_04: file(relativePath: { eq: "community_04.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    guide: file(relativePath: { eq: "guide.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

const Home = ({ data }) => {
  const steps = [
    {
      title: "Define the scope and assign roles",
      description:
        "Plan which activities you’ll need, set a schedule and allocate budget. Add project milestones to set specific targets during your schedule. Invite your planning team to help develop the plan collaboratively.",
      thumbnail: "step_01",
    },
    {
      title: "Get the resources you need",
      description:
        "Use the Hub to export a Geo-Referenced PDF that includes the data layers you need. Access any historical treatments or historical documents you need to aid in planning.",
      thumbnail: "step_02",
    },
    {
      title: "Import or draw GIS data",
      description:
        "Import treatment and structural protection data, such as values at risk. If you haven’t got a GIS export, the Hub includes GIS drawing tools for both data types.",
      thumbnail: "step_03",
    },
    {
      title: "Create the plan",
      description:
        "Upload your mitigation strategy and any other associated documents you’d like to store online. Then, create an online wildfire preparedness guide using the Hub’s wizard. The Hub includes a plan preview mode for you and your planning team to review the plan when you’re ready to publish.",
      thumbnail: "step_04",
    },
    {
      title: "Publish the plan",
      description:
        "Your plan can be public and shared with all, or private, so it’s only available to you and emergency services.",
      thumbnail: "step_05",
    },
  ];
  const communities = [
    "Athabasca",
    "Bayview Beach",
    "Beaver Lake",
    "Bellvue",
    "Bennett Beach",
    "Birch Grove Estates",
    "Blairmore",
    "Blaise Resort",
    "Bonesville",
    "Bragg Creek",
    "Buffalo Lake Metis Settlement",
    "Calling Lake",
    "Coleman",
    "Clearwater Cove and Ulliac Beach",
    "Deer Ridge Park",
    "Edson",
    "Elinor Lake Estates",
    "Evan Thomas Public Recreation Area, Peter Lougheed Provincial Park",
    "Fork Lake Estates",
    "Fork Lake Subdivision",
    "Fox Creek",
    "Frank",
    "Gift Lake Metis Settlement",
    "Golden Sands",
    "Greenbank Estates",
    "Harvey Heights",
    "Heart Lake No. 167",
    "High Level",
    "Hillcrest",
    "Hinton",
    "Holowachuk",
    "Horburg",
    "Hylo",
    "Imperial Mills",
    "Lac Des Arcs",
    "Lac La Biche",
    "Lakeview Estates",
    "Missawawi",
    "Mission",
    "Philomena",
    "Plamondon",
    "Poplar Point",
    "Slave Lake",
    "Square Lake",
    "Swan Hills",
    "Venice",
    "Wabasca",
    "Whitecourt",
  ];

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  ReactModal.setAppElement("body");

  return (
    <Layout>
      <div className={styles.wrapper}>
        <section className={styles.heroWrap}>
          <div className={styles.heroTop}>
            <div className={styles.container}>
              <div className={styles.heroContent}>
                <h1 className={styles.title}>The FireSmart Hub</h1>
                <h3 className={styles.subTitle}>
                  The easiest and most flexible way to create a community
                  FireSmart plan.
                </h3>
                <div className={styles.heroActions}>
                  <button className={styles.primary} onClick={openModal}>
                    <span className={styles.icon}>
                      <FaPlayCircle />
                    </span>
                    See it in Action
                  </button>
                  <button
                    className={styles.secondary}
                    onClick={() => scrollTo("#intro")}
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.wave}></div>
          <div className={styles.graphic}></div>
        </section>
        <section className={styles.introWrap} id="intro">
          <div className={styles.introBg}>
            <div className={styles.introInfo}>
              <h2 className={styles.introTitle}>Ready for wildfire season? </h2>
              <h4>
                Is your plan up-to-date and available for emergency services in
                the event that wildfire threatens your community?
              </h4>
            </div>
            <div className={styles.introDemo}></div>
          </div>
          <div className={styles.introContent}>
            <p>
              The FireSmart Hub provides the tools communities need to ensure
              their plan is available to those who need it, when they need it.
              It houses your plan 24/7,eases plan maintenance, know the history
              of the work, communities can develop it on their own. Minimizes
              contracting costs because it’s easy to use.
            </p>
          </div>
        </section>
        <section className={styles.howItWorks}>
          <div className={styles.container}>
            <h2>How it works</h2>
            <ul className={styles.steps}>
              {steps.map((s, index) => (
                <li className={styles.step} key={index}>
                  <div className={styles.stepContent}>
                    <h3 className={styles.title}>{s.title}</h3>
                    <p className={styles.description}>{s.description}</p>
                  </div>
                  <Img
                    className={styles.stepThumbnail}
                    fluid={data[s.thumbnail].childImageSharp.fluid}
                  />
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className={styles.communityWrap}>
          <div className={styles.container}>
            <h2>Communities with Plans in the Hub</h2>
            <ul className={styles.communities}>
              {communities.map((community, index) => (
                <li key={index} className={styles.community}>
                  {community}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className={styles.wpgGuideWrap}>
          <div className={styles.container}>
            <div className={styles.resourceInfo}>
              <h2>Need a resource to help get you started?</h2>
              <h4>
                Download a copy of Developing a Wildfire Preparedness Guide.
              </h4>
              <p>
                This manual is a reference for municipal representatives,
                community leaders, contract planners and government employees
                for use during the planning, development and updating of WPG
                documents. It contains a methodology, an example template, and
                additional information developed by Alberta Wildfire with input
                from various partners.
              </p>
              <a href={wpgGuide} download>
                <button className={styles.primary}>
                  <span className={styles.icon}>
                    <FaDownload />
                  </span>
                  Download
                </button>
              </a>
            </div>
            <Img
              className={styles.resourceThumbnail}
              fluid={data["guide"].childImageSharp.fluid}
            />
          </div>
        </section>

        <Contact />

        <ReactModal
          isOpen={isModalOpen}
          className={styles.modalContent}
          overlayClassName={styles.modalOverlay}
          bodyOpenClassName={styles.bodyModalOpen}
        >
          <button className={styles.closeModal} onClick={closeModal}>
            <MdClose />
          </button>
          <div className={styles.videoWrap}>
            <video controls autoPlay>
              <source src={TheFireSmartHub} type="video/mp4" />
            </video>
          </div>
        </ReactModal>
      </div>
    </Layout>
  );
};

export default Home;
